import { render, staticRenderFns } from "./editTask.vue?vue&type=template&id=04bd286d&scoped=true"
import script from "./editTask.vue?vue&type=script&lang=js"
export * from "./editTask.vue?vue&type=script&lang=js"
import style0 from "./editTask.vue?vue&type=style&index=0&id=04bd286d&lang=scss&scoped=true"
import style1 from "./editTask.vue?vue&type=style&index=1&id=04bd286d&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bd286d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04bd286d')) {
      api.createRecord('04bd286d', component.options)
    } else {
      api.reload('04bd286d', component.options)
    }
    module.hot.accept("./editTask.vue?vue&type=template&id=04bd286d&scoped=true", function () {
      api.rerender('04bd286d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/program/programTask/components/editTask.vue"
export default component.exports